<template>
	<AdminLayout>
		<div class="flex flex-row items-center">
			<p class="admin-center-subtitle">Styles Preview</p>
			<div>
				Dark Mode
				<DarkModeSwitcher class="ml-auto mr-6 border border-primary"/>
			</div>
		</div>

		<div class="mt-4 font-bold">
			Switch Themes:
			<button id="btn_aian" class="theme-switch px-4 py-2 mb-4 mr-4 border cursor-pointer" @click="changeTheme('aian')">AIAN</button>
			<button id="btn_comagine" class="theme-switch px-4 py-2 mb-4 mr-4 border cursor-pointer" @click="changeTheme('comagine')">Comagine</button>
			<button id="btn_esrd" class="theme-switch px-4 py-2 mb-4 mr-4 border cursor-pointer" @click="changeTheme('esrd')">ESRD</button>
			<button id="btn_care" class="theme-switch px-4 py-2 mb-4 mr-4 border cursor-pointer" @click="changeTheme('care')">CARE</button>
			<button id="btn_zoo" class="theme-switch px-4 py-2 mb-4 mr-4 border cursor-pointer" @click="changeTheme('zoo')">ZOO</button>
		</div>

		<!-- BUTTONS -->
		<div class="style-group text-group">
			<div class="section" @click.prevent="showSections['buttons']=!showSections['buttons'];">
				<div class="section-title">Buttons / MultiButtonModal</div>
				<div class="section-toggle">
					<img v-if="showSections['buttons']" src="@/assets/images/icon/minus.svg" alt="-" title="Collapse" >
					<img v-else src="@/assets/images/icon/plus.svg" alt="+" title="Expand">
				</div>
			</div>

			<div v-show="showSections['buttons']" >
				<div class="w-full py-2">
						<!-- Radio Button Group to set what type of Multi Button Modal to show -->
						<RadioGroup v-model="selected">
							<RadioGroupLabel class="font-bold underline">MultiButtonModal Type</RadioGroupLabel>
							<div class="space-x-4 flex flex-row w-100 mt-2">
								<RadioGroupOption as="template" v-for="plan in plans" :key="plan.name" :value="plan" v-slot="{ checked }" >
									<div
										:class="[
										 checked ? 'bg-primary text-white ' : 'bg-white ',
									  ]"
										class="relative flex cursor-pointer rounded-lg px-3 py-2 shadow-md shadow-icon-neutral focus:outline-none w-full"
									>
										<div class="flex w-full items-center justify-between">
											<div class="flex items-center">
												<div class="text-sm">
													<RadioGroupLabel as="p" :class="checked ? 'text-white' : 'text-grayscale-body'" class="font-medium" >
														{{ plan.name }}
													</RadioGroupLabel>
												</div>
											</div>
											<div v-show="checked" class="shrink-0 text-white">
												<svg class="h-6 w-6" viewBox="0 0 24 24" fill="none">
													<circle cx="12" cy="12" r="12" fill="#fff" fill-opacity="0.2" />
													<path d="M7 13l3 3 7-7" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
												</svg>
											</div>
										</div>
									</div>
								</RadioGroupOption>
							</div>
						</RadioGroup>
				</div>

				<p class="text-lg font-semibold my-4">Buttons - Regular</p>
				<div class="flex w-full space-x-2">
					<div class="flex flex-col space-y-2">
						<SubmitButton label="Default" @click="showAlert" />
						<SubmitButton label="Default loading" :loading="true" @click="showAlert" />
						<SubmitButton label="Default disabled" :disabled="true" @click="showAlert" />
					</div>

					<div class="flex flex-col space-y-2">
						<SubmitButton label="Outline" type="outline" @click="showAlert" />
						<SubmitButton label="Outline loading" type="outline" :loading="true" @click="showAlert" />
						<SubmitButton label="Outline disabled" type="outline" disabled @click="showAlert" />
					</div>

					<div class="flex flex-col space-y-2">
						<SubmitButton label="Warning" type="warning" @click="showAlert" />
						<SubmitButton label="Warning loading" type="warning" :loading="true" @click="showAlert" />
						<SubmitButton label="Warning disabled" type="warning" disabled @click="showAlert" />
					</div>
				</div>

				<p class="text-lg font-semibold my-4">Buttons - Small</p>
				<div class="flex w-full space-x-2">
					<div class="flex flex-col space-y-2">
						<SubmitButton label="Default" size="small" @click="showAlert" />
						<SubmitButton label="Default loading" size="small" :loading="true" @click="showAlert" />
						<SubmitButton label="Default disabled" size="small" disabled @click="showAlert" />
					</div>

					<div class="flex flex-col space-y-2">
						<SubmitButton label="Outline" type="outline" size="small" @click="showAlert" />
						<SubmitButton label="Outline loading" type="outline" size="small" :loading="true" @click="showAlert" />
						<SubmitButton label="Outline disabled" size="small" type="outline" disabled @click="showAlert" />
					</div>

					<div class="flex flex-col space-y-2">
						<SubmitButton label="Warning" type="warning" size="small" @click="showAlert" />
						<SubmitButton label="Warning loading" type="warning" size="small" :loading="true" @click="showAlert" />
						<SubmitButton label="Warning disabled" size="small" type="warning" disabled @click="showAlert" />
					</div>
				</div>

				<p class="text-lg font-semibold my-4">Buttons - ButtonSize.ExtraSmall</p>
				<div class="flex w-full space-x-2">
					<div class="flex flex-col space-y-2">
						<SubmitButton label="Default" :size="ButtonSize.ExtraSmall" @click="showAlert" />
						<SubmitButton label="Default loading" :size="ButtonSize.ExtraSmall" :loading="true" @click="showAlert" />
						<SubmitButton label="Default disabled" :size="ButtonSize.ExtraSmall" disabled @click="showAlert" />
					</div>

					<div class="flex flex-col space-y-2">
						<SubmitButton label="Outline" type="outline" :size="ButtonSize.ExtraSmall" @click="showAlert" />
						<SubmitButton label="Outline loading" type="outline" :size="ButtonSize.ExtraSmall" :loading="true" @click="showAlert" />
						<SubmitButton label="Outline disabled" :size="ButtonSize.ExtraSmall" type="outline" disabled @click="showAlert" />
					</div>

					<div class="flex flex-col space-y-2">
						<SubmitButton label="Warning" type="warning" :size="ButtonSize.ExtraSmall" @click="showAlert" />
						<SubmitButton label="Warning loading" type="warning" :size="ButtonSize.ExtraSmall" :loading="true" @click="showAlert" />
						<SubmitButton label="Warning disabled" :size="ButtonSize.ExtraSmall" type="warning" disabled @click="showAlert" />
					</div>
				</div>
			</div>
		</div>

		<!-- INPUTS -->
		<div class="style-group text-group">
			<div class="section" @click.prevent="showSections['inputs']=!showSections['inputs'];">
				<div class="section-title">Form Inputs</div>
				<div class="section-toggle">
					<img v-if="showSections['inputs']" src="@/assets/images/icon/minus.svg" alt="-" title="Collapse" >
					<img v-else src="@/assets/images/icon/plus.svg" alt="+" title="Expand">
				</div>
			</div>

			<div v-show="showSections['inputs']" >
				<!-- Disable/Readonly toggles -->
				<div class="flex flex-row my-2">
					<div id="disable_inputs_wrapper" class="mr-4">
						<div class="inline-block h-[28px] align-top mr-2">Disable</div>
						<ToggleSwitch screen_reader_text="Toggle Disable" v-model="input_disable" bg_enabled_off="bg-hi-warning" bg_enabled_on="bg-secondary"></ToggleSwitch>
					</div>
					<div id="readonly_inputs_wrapper">
						<div class="inline-block h-[28px] align-top mr-2">Readonly</div>
						<ToggleSwitch screen_reader_text="Toggle Readonly" v-model="input_readonly" bg_enabled_off="bg-hi-warning" bg_enabled_on="bg-secondary" size="small"></ToggleSwitch>
					</div>
					<div class="ml-5">
						<div class="inline-block h-[28px] align-top mr-2">Toggle</div>
						<ToggleSwitch screen_reader_text="Generic Toggle" :disabled="input_disable" v-model="generic_switch" size="tiny" class="mt-1"></ToggleSwitch>
					</div>
				</div>

				<div class="form-inputs">
					<div class="input-group">
						<p class="text-lg font-semibold my-4">Checkboxes</p>
						<div class="flex flex-col space-y-2">
							<CheckBox label="Normal"/>
							<CheckBox label="Normal - Disabled" :disabled="true"/>
							<CheckBox label="Checked" :model-value="true"/>
							<CheckBox label="Checked - Disabled" :model-value="true" :disabled="true"/>
							<CheckBox label="Error" :has-error="true"/>
							<CheckBox label="Error - Disabled" :has-error="true" :disabled="true"/>
							<CheckBox label="Error Checked" :has-error="true" :model-value="true"/>
							<CheckBox label="Error Checked - Disabled" :has-error="true" :model-value="true" :disabled="true"/>
						</div>
					</div>

					<div class="input-group">
						<p class="text-lg font-semibold my-4">Combobox</p>
						<Combobox id="combo_add_org_state" class="w-50" v-model="selected_state" :items="states" title="State" placeholder="Select state"
									 label-text-size="text-sm"
									 :show-options-on-top="true" input-height="h-10" :disabled="input_disable" :readonly="input_readonly"
						/>
						<br/><hr/><br/>
						<Combobox id="combo_add_org_state2" class="w-50" v-model="selected_state2" :items="states" title="State - Error" placeholder="Select state"
									 label-text-size="text-sm"
									 :show-options-on-top="true" input-height="h-10" :readonly="input_readonly"
									 :errors="inputValidationError"
									 error-field="field"
									 :disabled="input_disable"
						/>
						<br/><hr/><br/>
						<Combobox id="combo_add_org_state3" class="w-50" v-model="selected_state3" :items="states"
									 title="State - Enterable"
									 placeholder="Select state"
									 label-text-size="text-sm"
									 :show-options-on-top="true" input-height="h-10" :readonly="input_readonly"
									 error-field="field"
									 :disabled="input_disable"
									 :enterable="true"
						/>
						<br/><hr/><br/>
						<Combobox id="combo_non_enterable" class="w-50" v-model="selected_state4" :items="states" title="State - Non-enterable" placeholder="Select state"
											label-text-size="text-sm" input-height="h-10" :readonly="true" :disabled="input_disable"
						/>
					</div>

					<div class="input-group">
						<p class="text-lg font-semibold my-4">ListBox</p>
						<p class="text-md font-semibold my-4">Options In Content</p>
						<list-box :inlineLabelIcon=true
									 :disabled="input_disable"
									 inlineLabel="Inline Label With Icon"
									 :items="listBoxInlineData"
									 itemClass="text-primary-hover"
									 v-model="listBoxInlineValue"
									 :showListBoxOutline="true"
									 :showSelectedOutline="true"
									 :showSelectedCheckmark="true"
									 :wrapItemText = "true">
							<template v-slot:inline-label-icon>
								<!-- Icon shown next to "My Organizations" -->
								<svg width="22" height="22" viewBox="0 0 20 20" fill="current" xmlns="http://www.w3.org/2000/svg">
									<title>My Organizations</title>
									<path d="M17.9062 5.09375H15.125V4.5625C15.125 3.90625 14.6562 3.375 14.0625 3.25V1.875C14.0625 1.15625 13.4688 0.53125 12.7188 0.53125H7.25C6.53125 0.5625 5.9375 1.15625 5.9375 1.875V3.25C5.3125 3.375 4.875 3.90625 4.875 4.5625V5.09375H2.09375C1.25 5.09375 0.5625 5.78125 0.5625 6.625V17.5312C0.5625 18.5938 1.40625 19.4375 2.46875 19.4375H17.5625C18.625 19.4375 19.4688 18.5938 19.4688 17.5312V6.625C19.4688 5.78125 18.7812 5.09375 17.9062 5.09375ZM7.34375 1.96875H12.6875V3.21875H7.34375V1.96875ZM1.96875 17.5312V6.625C1.96875 6.5625 2.03125 6.5 2.09375 6.5H4.875V18.0625H2.46875C2.1875 18.0625 1.96875 17.8125 1.96875 17.5312ZM10.4062 18.0625H9.59375H9.3125V14.0312H10.7188V18.0312H10.4062V18.0625ZM12.125 18.0625V13.3438C12.125 12.9688 11.8125 12.625 11.4062 12.625H8.59375C8.21875 12.625 7.875 12.9375 7.875 13.3438V18.0625H6.25V4.625H13.75V18.0625H12.125ZM18.0625 17.5312C18.0625 17.8125 17.8438 18.0312 17.5625 18.0312H15.1562V6.46875H17.9375C18 6.46875 18.0625 6.53125 18.0625 6.59375V17.5312Z"/>
									<path d="M11.375 7.15613H10.6875V6.46863C10.6875 6.09363 10.375 5.74988 9.96875 5.74988C9.59375 5.74988 9.25 6.06238 9.25 6.46863V7.15613H8.5625C8.1875 7.15613 7.84375 7.46863 7.84375 7.87488C7.84375 8.28113 8.15625 8.59363 8.5625 8.59363H9.25V9.28113C9.25 9.65613 9.5625 9.99988 9.96875 9.99988C10.3437 9.99988 10.6875 9.68738 10.6875 9.28113V8.59363H11.375C11.75 8.59363 12.0938 8.28113 12.0938 7.87488C12.0938 7.46863 11.7813 7.15613 11.375 7.15613Z"/>
								</svg>
							</template>
						</list-box>
						<br/><hr/><br/>
						<list-box
							:inlineLabelIcon=false
							inlineLabel="Inline Label No Icon"
							:items="listBoxInlineData"
							itemClass="text-primary-hover"
							v-model="listBoxInlineValue"
							:showListBoxOutline="true"
							:showSelectedOutline="true"
							:showSelectedCheckmark="true"
							:showOptionsBorder="true"
							:wrapItemText = "true"
							error-field="field"
							:errors="inputValidationError"
							:disabled="input_disable"
						>
						</list-box>
						<br/><hr/><br/>
						<list-box
							label="Selected Item - Outline"
							:inlineLabelIcon=false
							:items="listBoxInlineData"
							itemClass="text-primary-hover"
							v-model="listBoxInlineValue"
							:showListBoxOutline="true"
							:showSelectedOutline="true"
							:showSelectedCheckmark="true"
							:wrapItemText = "true"
							error-field="field"
							:errors="inputValidationError"
							:disabled="input_disable"
						>
						</list-box>
						<br/><hr/><br/>

						<list-box
							label="Selected Item - No Outline/Checkbox"
							:inlineLabelIcon=false
							:items="listBoxData"
							itemClass="text-primary-hover"
							v-model="listBoxValue"
							:showListBoxOutline="true"
							:showSelectedOutline="false"
							:showSelectedCheckmark="true"
							:wrapItemText = "true"
							error-field="field"
							:disabled="input_disable"
						>
						</list-box>
						<br/><hr/><br/>
						<list-box
							label="Selected Item - No Outline/No Checkbox"
							:inlineLabelIcon=false
							:items="listBoxBlankData"
							itemClass="text-primary-hover"
							v-model="listBoxBlankValue"
							:showListBoxOutline="true"
							:showSelectedOutline="false"
							:showSelectedCheckmark="false"
							:wrapItemText = "true"
							error-field="field"
							:disabled="input_disable"
						>
						</list-box>
						<br/><hr/><br/>
						<div class="h-30 overflow-hidden">
							<list-box
								label="showOptionsOutsideModal - Wrapped by overflow-hidden"
								:inlineLabelIcon=false
								:items="listBoxModalData"
								itemClass="text-primary-hover"
								v-model="listBoxModalValue"
								:showListBoxOutline="true"
								:showSelectedOutline="false"
								:showSelectedCheckmark="false"
								:showOptionsOutsideModal="true"
								:wrapItemText = "true"
								error-field="field"
								:disabled="input_disable"
							>
							</list-box>
						</div>

					</div>

					<div class="input-group">
						<p class="text-lg font-semibold my-4">InputText</p>
						<InputText label="Organization name" type="text" placeholder="Enter organization name" input-height="h-10" label-text-size="text-sm" :disabled="input_disable" />
						<br/><hr/><br/>
						<InputText label="Organization name" icon="edit" type="text" placeholder="Enter organization name" input-height="h-10" label-text-size="text-sm" error-field="field" :disabled="input_disable" :errors="inputValidationError" />
						<br/><hr/><br/>
						<InputText label="Email" :icon="InputIcon.EMAIL" type="text" placeholder="Enter organization name" input-height="h-10" label-text-size="text-sm" :disabled="input_disable"  />
						<br/><hr/><br/>
						<InputText label="Text Area" type="textarea" placeholder="Description" label-text-size="text-sm" :disabled="input_disable"  />
						<br/><hr/><br/>
						<InputText label="Text w/ Edit Modal" type="text" placeholder="Description" label-text-size="text-sm" :disabled="input_disable" v-model="input_edit_modal_text1" :use-edit-modal="true" :edit-modal-config="inputEditModal1Config"  />
						<br/><hr/><br/>
						<InputText label="Text Area w/ Edit Modal" type="textarea" placeholder="Description" label-text-size="text-sm" :disabled="input_disable" v-model="input_edit_modal_text2" :use-edit-modal="true" :edit-modal-config="inputEditModal2Config" />
					</div>

					<div class="input-group">
						<p class="text-lg font-semibold my-4">DatePicker</p>
						<DatePicker id="date_value" label="Open date" label-text-size="text-sm" placeholder="Open date"
										:model-value="date_value" class="flex-grow " custom-classes="placeholder-default" :disabled="input_disable" />
						<br/><hr/><br/>
						<DatePicker id="date_value2" label="Open date" label-text-size="text-sm" placeholder="Open date"
										:model-value="date_value2"
										:errors="inputValidationError"
										error-field="field"
										class="flex-grow " custom-classes="placeholder-default" :disabled="input_disable" />
					</div>
				</div>
			</div>
		</div>

		<!-- Tailwind -->
		<div class="border border-neutral-sublte p-2 mb-4 rounded">
			<div class="text-xl font-bold mb-4">Tailwind Color Definitions</div>
			<div>
				<!-- Text -->
				<div class="style-group text-group">
					<div class="section" @click.prevent="showSections['text']=!showSections['text'];">
						<div class="section-title">Text</div>
						<div class="section-toggle">
							<img v-if="showSections['text']" src="@/assets/images/icon/minus.svg" alt="-" title="Collapse" >
							<img v-else src="@/assets/images/icon/plus.svg" alt="+" title="Expand">
						</div>
					</div>

					<div v-show="showSections['text']" class="color-content">
						<div class="applies-to">Tailwind tag: text-</div>
						<div class="example">Examples: text-primary, text-heading, text-body</div>
						<table>
							<tbody>
							<tr><td class="font-bold" colspan="2">Placeholders</td></tr>
							<tr><td></td><td>Tailwind tag: placeholder-</td></tr>
							<tr><td></td><td>Examples: placeholder-default</td></tr>
							<tr><td>default</td><td><input type="text" class="ml-2 placeholder-default" placeholder="placeholder-default" /></td><td>{{ getRGB('neutral-500') }}</td></tr>
							<tr><td>on-color</td><td><input type="text" class="ml-2 placeholder-on-color bg-primary" placeholder="placeholder-on-color" /></td><td>{{ getRGB('neutral-100') }}</td></tr>
							</tbody>
						</table>

						<br/>

						<table class='colors'>
							<tbody>
							<tr><td>Text/Default</td></tr>
							<tr><td class='text-heading'>heading<br/>{{ getRGB('primary-950') }}</td></tr>
							<tr><td class='text-body'>body<br/>{{ getRGB('primary-950') }}</td></tr>
							<tr><td class='text-label'>label<br/>{{ getRGB('primary-950') }}</td></tr>
							<tr><td class='text-caption'>caption<br/>{{ getRGB('primary-950') }}</td></tr>
							<tr><td class='text-placeholder'>placeholder<br/>{{ getRGB('neutral-500') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Text/On-Color</td></tr>
							<tr><td class='text-heading-on-color bg-primary'>heading-on-color<br/>{{ getRGB('foundations-white') }}</td></tr>
							<tr><td class='text-body-on-color bg-primary'>body-on-color<br/>{{ getRGB('foundations-white') }}</td></tr>
							<tr><td class='text-label-on-color bg-primary'>label-on-color<br/>{{ getRGB('foundations-white') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Text/Primary</td></tr>
							<tr><td class='text-primary'>primary<br/>{{ getRGB('primary-700') }}</td></tr>
							<tr><td class='text-primary-hover'>primary-hover<br/>{{ getRGB('primary-500') }}</td></tr>
							<tr><td class='text-primary-subtle-hover'>primary-subtle-hover<br/>{{ getRGB('primary-600') }}</td></tr>
							<tr><td class='text-primary-light'>primary-light<br/>{{ getRGB('primary-200') }}</td></tr>
							<tr><td class='text-primary-dark'>primary-dark<br/>{{ getRGB('primary-800') }}</td></tr>
							<tr><td class='text-primary-dark'>primary-darker<br/>{{ getRGB('primary-900') }}</td></tr>
							<tr><td class='text-primary-darkest'>primary-darkest<br/>{{ getRGB('primary-950') }}</td></tr>
							<tr><td class='text-primary-on-color bg-primary'>primary-on-color<br/>{{ getRGB('foundations-white') }}</td></tr>
							<tr><td class='text-primary-on-color-hover bg-primary'>primary-on-color-hover<br/>{{ getRGB('foundations-white') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Text/Grayscale</td></tr>
							<tr><td class='text-grayscale-body'>grayscale-body<br/>{{ getRGB('grayscale-700') }}</td></tr>
							<tr><td class='text-grayscale-body-light'>grayscale-body-light<br/>{{ getRGB('grayscale-600') }}</td></tr>
							<tr><td class='text-grayscale-body-dark'>grayscale-body-dark<br/>{{ getRGB('grayscale-800') }}</td></tr>
							<tr><td class='text-grayscale-body-on-color bg-disabled-subtle'>grayscale-body-on-color<br/>{{ getRGB('foundations-white') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Text/Disabled</td></tr>
							<tr><td class='text-disabled'>disabled<br/>{{ getRGB('neutral-500') }}</td></tr>
							<tr><td class='text-disabled-on-color'>disabled-on-color<br/>{{ getRGB('neutral-200') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Text/Accent</td></tr>
							<tr><td class='text-accent'>accent<br/>{{ getRGB('accent-400') }}</td></tr>
							<tr><td class='text-accent-on-color bg-primary'>accent-on-color<br/>{{ getRGB('foundations-white') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Text/Neutral</td></tr>
							<tr><td class='text-neutral'>neutral<br/>{{ getRGB('neutral-600') }}</td></tr>
							<tr><td class='text-neutral-subtle'>neutral-subtle<br/>{{ getRGB('neutral-500') }}</td></tr>
							<tr><td class='text-neutral-on-color bg-primary'>neutral-on-color<br/>{{ getRGB('foundations-white') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Text/Lo-Warning</td></tr>
							<tr><td class='text-lo-warning'>lo-warning<br/>{{ getRGB('lo-warning-600') }}</td></tr>
							<tr><td class='text-lo-warning-on-color'>lo-warning-on-color<br/>{{ getRGB('lo-warning-600') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Text/Hi-Warning</td></tr>
							<tr><td class='text-hi-warning'>hi-warning<br/>{{ getRGB('hi-warning-500') }}</td></tr>
							<tr><td class='text-hi-warning-on-color'>hi-warning-on-color<br/>{{ getRGB('hi-warning-700') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Text/Success</td></tr>
							<tr><td class='text-success'>success<br/>{{ getRGB('success-600') }}</td></tr>
							<tr><td class='text-success-on-color'>success-on-color<br/>{{ getRGB('success-700') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Text/Information</td></tr>
							<tr><td class='text-information'>information<br/>{{ getRGB('information-600') }}</td></tr>
							<tr><td class='text-information-on-color'>information-on-color<br/>{{ getRGB('information-700') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Text/Error</td></tr>
							<tr><td class='text-error'>error<br/>{{ getRGB('error-600') }}</td></tr>
							<tr><td class='text-error-on-color'>error-on-color<br/>{{ getRGB('error-700') }}</td></tr>
							</tbody>
						</table>
					</div>
				</div>

				<!-- Icon -->
				<div class="style-group">
					<div class="section" @click.prevent="showSections['icon']=!showSections['icon'];">
						<div class="section-title">Icon</div>
						<div class="section-toggle">
							<img v-if="showSections['icon']" src="@/assets/images/icon/minus.svg" alt="-" title="Collapse" >
							<img v-else src="@/assets/images/icon/plus.svg" alt="+" title="Expand" >
						</div>
					</div>
					<div v-show="showSections['icon']" class="color-content">
						<div class="applies-to">Tailwind tag: all</div>
						<div class="example">Examples: fill-primary-dark bg-icon-primary-dark, border-icon-primary-body<div class="ml-4 italic">Since icon colors could be applied to multiple css types they're not under a specific group.</div></div>
						<table class='colors'>
							<tbody>
							<tr><td>Icon/Primary</td></tr>
							<tr><td class='bg-icon-primary-dark text-icon-primary-on-color'>icon-primary-dark<br/>{{ getRGB('primary-950') }}</td></tr>
							<tr><td class='bg-icon-primary-hover'>icon-primary-hover<br/>{{ getRGB('primary-600') }}</td></tr>
							<tr><td class='bg-icon-primary-pressed'>icon-primary-pressed<br/>{{ getRGB('primary-600') }}</td></tr>
							<tr><td class='bg-icon-primary'>icon-primary<br/>{{ getRGB('primary-700') }}</td></tr>
							<tr><td class='bg-icon-primary-on-color'>icon-primary-on-color<br/>{{ getRGB('foundations-white') }}</td></tr>
							<tr><td class='bg-icon-primary-on-color-hover'>icon-primary-on-color-hover<br/>{{ getRGB('primary-300') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Icon/Accent</td></tr>
							<tr><td class='bg-icon-accent'>icon-accent<br/>{{ getRGB('accent-450') }}</td></tr>
							<tr><td class='bg-icon-accent-light'>icon-accent-light<br/>{{ getRGB('accent-400') }}</td></tr>
							<tr><td class='bg-icon-accent-on-color'>icon-accent-on-color<br/>{{ getRGB('foundations-white') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Icon/Disabled</td></tr>
							<tr><td class='bg-icon-disabled'>icon-disabled<br/>{{ getRGB('neutral-400') }}</td></tr>
							<tr><td class='bg-icon-disabled-on-color text-primary-on-color'>icon-disabled-on-color<br/>{{ getRGB('neutral-800') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Icon/Neutral</td></tr>
							<tr><td class='bg-icon-neutral'>icon-neutral<br/>{{ getRGB('neutral-500') }}</td></tr>
							<tr><td class='bg-icon-neutral-hover'>icon-neutral-hover<br/>{{ getRGB('neutral-600') }}</td></tr>
							<tr><td class='bg-icon-neutral-hover-dark text-primary-on-color'>icon-neutral-hover-dark<br/>{{ getRGB('neutral-700') }}</td></tr>
							<tr><td class='bg-icon-neutral-on-color'>icon-neutral-on-color<br/>{{ getRGB('neutral-100') }}</td></tr>
							<tr><td class='bg-icon-neutral-on-color-hover'>icon-neutral-on-color-hover<br/>{{ getRGB('foundations-white') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Icon/Low-Warning</td></tr>
							<tr><td class='bg-icon-lo-warning'>icon-lo-warning<br/>{{ getRGB('lo-warning-600') }}</td></tr>
							<tr><td class='bg-icon-lo-warning-on-color'>icon-lo-warning-on-color<br/>{{ getRGB('lo-warning-200') }}</td></tr> <!-- extends bg-lo-warning-on-color -->
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Icon/Hi-Warning</td></tr>
							<tr><td class='bg-icon-hi-warning'>icon-hi-warning<br/>{{ getRGB('hi-warning-400') }}</td></tr>
							<tr><td class='bg-icon-hi-warning-on-color text-primary-on-color'>icon-hi-warning-on-color<br/>{{ getRGB('hi-warning-700') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Icon/Success</td></tr>
							<tr><td class='bg-icon-success'>icon-success<br/>{{ getRGB('success-400') }}</td></tr>
							<tr><td class='bg-icon-success-on-color text-primary-on-color'>icon-success-on-color<br/>{{ getRGB('success-700') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Icon/Info</td></tr>
							<tr><td class='bg-icon-information'>icon-information<br/>{{ getRGB('information-500') }}</td></tr>
							<tr><td class='bg-icon-information-on-color text-primary-on-color'>icon-information-on-color<br/>{{ getRGB('information-700') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Icon/Error</td></tr>
							<tr><td class='bg-icon-error'>icon-error<br/>{{ getRGB('accent-500') }}</td></tr>
							<tr><td class='bg-icon-error-on-color text-primary-on-color'>icon-error-on-color<br/>{{ getRGB('accent-700') }}</td></tr>
							</tbody>
						</table>
					</div>
				</div>

				<!-- Surface -->
				<div class="style-group">
					<div class="section" @click.prevent="showSections['surface']=!showSections['surface'];">
						<div class="section-title">Surface (Backgrounds)</div>
						<div class="section-toggle">
							<img v-if="showSections['surface']" src="@/assets/images/icon/minus.svg" alt="-" title="Collapse">
							<img v-else src="@/assets/images/icon/plus.svg" alt="+" title="Expand" >
						</div>
					</div>

					<div v-show="showSections['surface']" class="color-content">
						<div class="applies-to">Tailwind tag: bg-</div>
						<div class="example">Examples: bg-primary, bg-accent</div>
						<table class='colors'>
							<tbody>
							<tr><td>Surface/Primary</td></tr>
							<tr><td class='bg-primary'>primary<br/>{{ getRGB('primary-700') }}</td></tr>
							<tr><td class='bg-primary-bold-hover'>primary-bold-hover<br/>{{ getRGB('primary-700') }}</td></tr>
							<tr><td class='bg-primary-subtle-hover'>primary-subtle-hover<br/>{{ getRGB('primary-600') }}</td></tr>
							<tr><td class='bg-primary-subtlest'>primary-subtlest<br/>{{ getRGB('primary-50') }}</td></tr>
							<tr><td class='bg-primary-subtler'>primary-subtler<br/>{{ getRGB('primary-100') }}</td></tr>
							<tr><td class='bg-primary-subtle'>primary-subtle<br/>{{ getRGB('primary-150') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Surface/Primary<br/>(continued)</td></tr>
							<tr><td class='bg-primary-lighter'>primary-lighter<br/>{{ getRGB('primary-300') }}</td></tr>
							<tr><td class='bg-primary-lightest'>primary-lightest<br/>{{ getRGB('primary-200') }}</td></tr>
							<tr><td class='bg-primary-dark text-primary-on-color'>primary-dark<br/>{{ getRGB('primary-800') }}</td></tr>
							<tr><td class='bg-primary-darker text-primary-on-color'>primary-darker<br/>{{ getRGB('primary-900') }}</td></tr>
							<tr><td class='bg-primary-darkest text-primary-on-color'>primary-darkest<br/>{{ getRGB('primary-950') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Surface/Accent</td></tr>
							<tr><td class='bg-accent'>accent<br/>{{ getRGB('accent-100') }}</td></tr>
							<tr><td class='bg-accent-light'>accent-light<br/>{{ getRGB('accent-200') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Surface/Secondary</td></tr>
							<tr><td class='bg-secondary-subtle'>secondary-subtle<br/>{{ getRGB('secondary-100') }}</td></tr>
							<tr><td class='bg-secondary'>secondary<br/>{{ getRGB('secondary-200') }}</td></tr>
							<tr><td class='bg-secondary-dark'>secondary-dark<br/>{{ getRGB('secondary-500') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Surface/Tertiary</td></tr>
							<tr><td class='bg-tertiary'>tertiary<br/>{{ getRGB('tertiary-500') }}</td></tr>
							<tr><td class='bg-tertiary-darker'>tertiary-darker<br/>{{ getRGB('tertiary-600') }}</td></tr>
							<tr><td class='bg-tertiary-on-color'>tertiary-on-color<br/>{{ getRGB('tertiary-100') }}</td></tr>
							<tr><td class='bg-tertiary-subtle'>tertiary-subtle<br/>{{ getRGB('tertiary-200') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Surface/Disabled</td></tr>
							<tr><td class='bg-disabled'>disabled<br/>{{ getRGB('neutral-400') }}</td></tr>
							<tr><td class='bg-disabled-subtle'>disabled-subtle<br/>{{ getRGB('neutral-200') }}</td></tr>
							<tr><td class='bg-disabled-subtlest'>disabled-subtlest<br/>{{ getRGB('neutral-100') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Surface/Neutral</td></tr>
							<tr><td class='bg-neutral'>neutral<br/>{{ getRGB('foundations-white') }}</td></tr>
							<tr><td class='bg-neutral-light'>neutral-light<br/>{{ getRGB('neutral-100') }}</td></tr>
							<tr><td class='bg-neutral-page'>neutral-page<br/>{{ getRGB('primary-25') }}</td></tr>
							<tr><td class='bg-neutral-button'>neutral-button<br/>{{ getRGB('neutral-600') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Surface/Low-Warning</td></tr>
							<tr><td class='bg-lo-warning-on-color'>lo-warning-on-color<br/>{{ getRGB('lo-warning-200') }}</td></tr>
							<tr><td class='bg-lo-warning-subtle'>lo-warning-subtle<br/>{{ getRGB('lo-warning-50') }}</td></tr>
							<tr><td class='bg-lo-warning'>lo-warning<br/>{{ getRGB('lo-warning-600') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Surface/Hi-Warning</td></tr>
							<tr><td class='bg-hi-warning'>hi-warning<br/>{{ getRGB('hi-warning-500') }}</td></tr>
							<tr><td class='bg-hi-warning-light'>hi-warning-light<br/>{{ getRGB('hi-warning-100') }}</td></tr>
							<tr><td class='bg-hi-warning-on-color'>hi-warning-on-color<br/>{{ getRGB('hi-warning-400') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Surface/Success</td></tr>
							<tr><td class='bg-success'>success<br/>{{ getRGB('success-50') }}</td></tr>
							<tr><td class='bg-success-on-color'>success-on-color<br/>{{ getRGB('success-400') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Surface/Information</td></tr>
							<tr><td class='bg-information'>information<br/>{{ getRGB('information-100') }}</td></tr>
							<tr><td class='bg-information-on-color'>information-on-color<br/>{{ getRGB('information-500') }}</td></tr>
							</tbody>
						</table>

						<table class='colors'>
							<tbody>
							<tr><td>Surface/Error</td></tr>
							<tr><td class='bg-error-light'>error-light<br/>{{ getRGB('error-100') }}</td></tr>
							<tr><td class='bg-error'>error<br/>{{ getRGB('error-600') }}</td></tr>
							<tr><td class='bg-error-on-color'>error-on-color<br/>{{ getRGB('error-500') }}</td></tr>
							</tbody>
						</table>
					</div>
				</div>

				<!-- Border -->
				<div class="style-group">
					<div class="section" @click.prevent="showSections['border']=!showSections['border'];">
						<div class="section-title">Border/Outline</div>
						<div class="section-toggle">
							<img v-if="showSections['border']" src="@/assets/images/icon/minus.svg" alt="-" title="Collapse" >
							<img v-else src="@/assets/images/icon/plus.svg" alt="+" title="Expand" >
						</div>
					</div>

					<div v-show="showSections['border']" class="color-content">
						<div class="applies-to">Tailwind tag: border-, outline-, ring-</div>
						<div class="example">Examples: border-primary, border-accent outline-error, outline-grayscale</div>
						<table class='border-colors'>
							<tbody>
							<tr><td>Border/Primary</td></tr>
							<tr><td class='border border-primary'>primary<br/>{{ getRGB('primary-700') }}</td></tr>
							<tr><td class='border border-primary-bold-hover'>primary-bold-hover<br/>{{ getRGB('primary-500') }}</td></tr>
							<tr><td class='border border-primary-subtle-hover'>primary-subtle-hover<br/>{{ getRGB('primary-600') }}</td></tr>
							<tr><td class='border border-primary-dark'>primary-dark<br/>{{ getRGB('primary-800') }}</td></tr>
							<tr><td class='border border-primary-darker'>primary-darker<br/>{{ getRGB('primary-900') }}</td></tr><!--paired/enhances with surface-primary-darker (background/fill)  -->
							<tr><td class='border border-primary-darkest'>primary-darkest<br/>{{ getRGB('primary-950') }}</td></tr>
							</tbody>
						</table>

						<table class='border-colors'>
							<tbody>
							<tr><td>Border/Secondary</td></tr>
							<tr><td class='border border-secondary'>secondary<br/>{{ getRGB('secondary-500') }}</td></tr>
							<tr><td class='border border-secondary-light'>secondary-light<br/>{{ getRGB('secondary-400') }}</td></tr>
							<tr><td class='border border-secondary-bold'>secondary-bold<br/>{{ getRGB('secondary-200') }}</td></tr>
							</tbody>
						</table>

						<table class='border-colors'>
							<tbody>
							<tr><td>Border/Tertiary</td></tr>
							<tr><td class='border border-tertiary'>tertiary<br/>{{ getRGB('tertiary-500') }}</td></tr>
							<tr><td class='border border-tertiary-light'>tertiary-light<br/>{{ getRGB('tertiary-400') }}</td></tr>
							<tr><td class='border border-tertiary-dark'>tertiary-dark<br/>{{ getRGB('tertiary-600') }}</td></tr>
							</tbody>
						</table>

						<table class='border-colors'>
							<tbody>
							<tr><td>Border/Accent</td></tr>
							<tr><td class='border border-accent'>accent<br/>{{ getRGB('accent-100') }}</td></tr>
							<tr><td class='border border-accent-bold'>accent-bold<br/>{{ getRGB('accent-400') }}</td></tr>
							</tbody>
						</table>

						<table class='border-colors'>
							<tbody>
							<tr><td>Border/Gray</td></tr>
							<tr><td class='border border-grayscale'>grayscale<br/>{{ getRGB('grayscale-700') }}</td></tr>
							<tr><td class='border border-grayscale-light'>grayscale-light<br/>{{ getRGB('grayscale-600') }}</td></tr>
							<tr><td class='border border-grayscale-dark'>grayscale-dark<br/>{{ getRGB('grayscale-800') }}</td></tr>
							<tr><td class='border border-grayscale-on-color'>grayscale-on-color<br/>{{ getRGB('grayscale-100') }}</td></tr>
							</tbody>
						</table>

						<table class='border-colors'>
							<tbody>
							<tr><td>Border/Disabled</td></tr>
							<tr><td class='border border-disabled'>disabled<br/>{{ getRGB('neutral-200') }}</td></tr>
							</tbody>
						</table>

						<table class='border-colors'>
							<tbody>
							<tr><td>Border/Neutral</td></tr>
							<tr><td class='border border-neutral'>neutral<br/>{{ getRGB('neutral-400') }}</td></tr>
							<tr><td class='border border-neutral-subtle'>neutral-subtle<br/>{{ getRGB('neutral-300') }}</td></tr>
							<tr><td class='border border-neutral-dark'>neutral-dark<br/>{{ getRGB('neutral-500') }}</td></tr>
							<tr><td class='border border-neutral-darker'>neutral-darker<br/>{{ getRGB('neutral-600') }}</td></tr>
							</tbody>
						</table>

						<table class='border-colors'>
							<tbody>
							<tr><td>Border/Low-Warning</td></tr>
							<tr><td class='border border-lo-warning'>lo-warning<br/>{{ getRGB('lo-warning-200') }}</td></tr>
							<tr><td class='border border-lo-warning-on-color'>lo-warning-on-color<br/>{{ getRGB('lo-warning-600') }}</td></tr>
							</tbody>
						</table>

						<table class='border-colors'>
							<tbody>
							<tr><td>Border/Hi-Warning</td></tr>
							<tr><td class='border border-hi-warning'>hi-warning<br/>{{ getRGB('hi-warning-400') }}</td></tr>
							<tr><td class='border border-hi-warning-on-color'>hi-warning-on-color<br/>{{ getRGB('hi-warning-500') }}</td></tr>
							</tbody>
						</table>

						<table class='border-colors'>
							<tbody>
							<tr><td>Border/Success</td></tr>
							<tr><td class='border border-success'>success<br/>{{ getRGB('success-400') }}</td></tr>
							</tbody>
						</table>

						<table class='border-colors'>
							<tbody>
							<tr><td>Border/Information</td></tr>
							<tr><td class='border border-information'>information<br/>{{ getRGB('information-500') }}</td></tr>
							</tbody>
						</table>

						<table class='border-colors'>
							<tbody>
							<tr><td>Border/Error</td></tr>
							<tr><td class='border border-error'>error<br/>{{ getRGB('error-600') }}</td></tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>

		<!-- TOASTS/BANNERS -->
		<div class="style-group text-group">
			<div class="section" @click.prevent="showSections['toasts']=!showSections['toasts'];">
				<div class="section-title">Toasts/Banners</div>
				<div class="section-toggle">
					<img v-if="showSections['toasts']" src="@/assets/images/icon/minus.svg" alt="-" title="Collapse" >
					<img v-else src="@/assets/images/icon/plus.svg" alt="+" title="Expand">
				</div>
			</div>

			<div v-show="showSections['toasts']" >
				<p class="text-lg font-semibold my-4">Toasts</p>
				<div class="flex w-full space-x-2">
					<SubmitButton label="Success" class="bg-[#C9FBEB] text-[#0C4E29]" @click="toaster.success('Your password has been updated successfully example text.', { timeout: false })" />
					<SubmitButton label="Warning Low" class="bg-[#FEF0C8] text-[#7A591A]" @click="toaster.warning('You must have example permissions to complete example task example text.', { timeout: false })" />
					<SubmitButton label="Error" class="bg-[#FBE0D0] text-[#8B0A03]" @click="toaster.error('Your upload failed example text.', { timeout: false })" />
					<SubmitButton label="Information" class="bg-[#DEE5FF] text-[#222FBF]" @click="toaster.info('Toast information or reminder text.', { timeout: false })" />
					<SubmitButton label="Warning High" class="bg-[#FFE2D1] text-[#782312]" @click="toaster.highWarning('Toast high level warning text.', { timeout: false })" />
				</div>

				<p class="text-lg font-semibold my-4">Banners</p>
				<div class="flex w-full space-x-2">
					<SubmitButton label="Success" class="bg-[#C9FBEB] text-[#0C4E29]" @click="banner.success('Your password has been updated successfully example text.')" />
					<SubmitButton label="Warning Low" class="bg-[#FEF0C8] text-[#7A591A]" @click="banner.warning('You must have example permissions to complete example task example text.')" />
					<SubmitButton label="Error" class="bg-[#FBE0D0] text-[#8B0A03]" @click="banner.error('Your upload failed example text.')" />
					<SubmitButton label="Information" class="bg-[#DEE5FF] text-[#222FBF]" @click="banner.info('Toast information or reminder text.')" />
					<SubmitButton label="Warning High" class="bg-[#FFE2D1] text-[#782312]" @click="banner.highWarning('Toast high level warning text.')" />
				</div>
			</div>
		</div>

		<!-- TABLE -->
		<div class="style-group text-group">
			<div class="section" @click.prevent="showSections['table']=!showSections['table'];">
				<div class="section-title">Table</div>
				<div class="section-toggle">
					<img v-if="showSections['table']" src="@/assets/images/icon/minus.svg" alt="-" title="Collapse" >
					<img v-else src="@/assets/images/icon/plus.svg" alt="+" title="Expand">
				</div>
			</div>

			<div class="overflow-x-auto" v-show="showSections['table']" >
				<PortalDataTable
					ref="table"
					:endpoints="endpoints"
				>
					<template #advanced-search>
						<div class="flex flex-row mr-1 mt-1 justify-end">
							<div class="flex w-full justify-end overflow-hidden">
								<Popper :content="`Data Submissions are considered to be archived after ${archiveAfterDays} days.`" hover arrow placement="bottom-start">
									<CheckBox input-id="cbx_archive" label="Include archived content" label-location="left" class="my-2" :checked="false" v-model="includeArchived" @checked-changed="toggleArchivedContent" />
								</Popper>
							</div>
						</div>
					</template>

					<template #actions="data">
						<div class="w-26">
							<EndpointTableCellMenu
								:items="actionMenuItems"
								:record="data.value"
								:disabled="false"
								width="w-26"
								@onMenuItemSelected="onMenuItemSelected"
								placement="bottom-start"
							/>
						</div>

					</template>

					<template #organization_name="data">
						<p class="endpoint-clickable-text whitespace-pre-wrap xl:whitespace-nowrap">
							{{ data.value.organization_name }}
						</p>
					</template>

					<template #created_at="data">
						{{ Format.date(data.value.created_at) }}
					</template>

					<template #status="data">
						<EndpointTableListBox
							:items="statusColumnData"
							:record-id="data.value.id"
							v-model="data.value.status"
							:showSelectedCheckmark="false"
							width="w-40"
							:disabled="false"
							@onItemSelected="onStatusItemSelected"
							:displayed-item-c-s-s="{ 'Disabled': '!bg-disabled-subtle !text-label', 'Active': '!bg-primary-lighter !text-label'}"
						></EndpointTableListBox>
					</template>

					<!-- Users -->
					<template #family_name="data">
						<p class="userpilot-mask endpoint-clickable-text whitespace-pre-wrap lg:whitespace-nowrap" @click.prevent="showTextAlert(`${data.value.given_name } ${ data.value.family_name}`)">
							{{ data.value.given_name }} {{ data.value.family_name }}
						</p>
					</template>

					<template #email="data">
						<div class="userpilot-mask flex flex-col w-fit space-x-0 space-y-1 2xl:flex-row 2xl:space-x-1 2xl:space-y-0">
							<span>{{ data.value.email }}</span>
							<span v-if="data.value.tfa_status === 'pending'" class="admin-center-login-status-tag-pending whitespace-pre-wrap lg:whitespace-nowrap">2FA Pending</span>
							<span v-if="data.value.tfa_status === 'expired'" class="admin-center-login-status-tag-tfa whitespace-pre-wrap lg:whitespace-nowrap">2FA Expired</span>
						</div>
					</template>

					<template #custom="data">
						<div class="flex flex-col">
							<span v-for="organization in data.value.organizations" :key="organization.id" class="text-wrap">
								<span class="endpoint-clickable-text" @click.prevent="showTextAlert(organization.organization_name)">{{ organization.organization_name + (organization.organization_name_dba ? " (" + organization.organization_name_dba + ")" : "") }}</span>
								<span v-if="organization.user_role"> / {{ organization.user_role }}</span>
							</span>
							<div class="button-outline w-fit flex flex-row mt-2 cursor-pointer rounded-md !px-2 !py-1" @click="showTextAlert('Add Org Clicked')">
								<div class="mt-1 mr-2">
									<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 23 24">
										<title>Add</title>
										<desc>Click to Add Organization</desc>
										<path d="M15.325 11.137h-3V8.175c0-.45-.375-.825-.862-.825-.45 0-.825.375-.825.862v2.963H7.675c-.45 0-.825.375-.825.862 0 .45.375.825.863.825h2.962v2.963c0 .45.375.825.863.825.45 0 .825-.375.825-.863v-2.962h2.962c.45 0 .825-.375.825-.863a.83.83 0 0 0-.825-.825"/>
										<path d="M11.5.675A11.315 11.315 0 0 0 .175 12c0 6.262 5.1 11.362 11.362 11.362S22.9 18.262 22.9 12C22.863 5.737 17.763.675 11.5.675m0 21c-5.325 0-9.637-4.35-9.637-9.675A9.634 9.634 0 0 1 11.5 2.362c5.325 0 9.675 4.313 9.675 9.638s-4.35 9.675-9.675 9.675"/>
									</svg>
								</div>
								<div>
									Add New Organization
								</div>
							</div>
						</div>
					</template>

					<template #deleted_at="data">
						<div class="flex w-full justify-center whitespace-nowrap">
							<EndpointTableListBox
								:record-id="data.value.id"
								:items="statusColumnData"
								v-model="data.value.status"
								:showSelectedCheckmark="false"
								width="w-26"
								@onItemSelected="onStatusItemSelected"
								:displayed-item-c-s-s="{ 'Disabled': '!bg-disabled-subtle !text-label', 'Active': '!bg-primary-lighter !text-label'}"
							/>
						</div>
					</template>

					<!-- User Invites -->
					<template #organization="data">
						<p class="endpoint-clickable-text whitespace-pre-wrap xl:whitespace-nowrap w-fit" :class="[{ 'line-through': data.value.organization?.deleted_at }]"
						   @click.prevent="showTextAlert(data.value.organization?.organization_name)">
							{{ data.value.organization?.organization_name }}<br>{{ (data.value.organization?.organization_name_dba ? "(" + data.value.organization?.organization_name_dba + ")" : "") }}
						</p>
					</template>

					<template #error_message="data">
						{{ data.value.error_message }}
					</template>

					<template #resend="data">
						<div class="flex w-full justify-center whitespace-nowrap">
							<SubmitButton :disabled="!data.value.expired" label="Resend" :size="ButtonSize.EndpointTable" @click="showTextAlert(data.value.id)" ></SubmitButton>
						</div>
					</template>
				</PortalDataTable>
			</div>
		</div>

		<Teleport to="html">
			<MultiButtonModal
				:show="showModal"
				:icon="selected.type"
				title="Delete Database"
				message="Are you sure?"
				subMessage="Leaving now will discard any changes made."
				:buttons="[
									new ModalButtonData(
										'Cancel', hideModal, ButtonType.Default, ButtonSize.Small
									),
									new ModalButtonData(
										'Yes', hideModal, ButtonType.Default, ButtonSize.Small
									)
								]"
			/>
		</Teleport>

	</AdminLayout>
</template>

<script setup lang="js">
import AdminLayout from '@/layouts/AdminLayout.vue'
import SubmitButton from '@/components/Forms/Buttons/SubmitButton.vue'
import { computed, onBeforeMount, onMounted, ref } from 'vue'
import router from '@/router/router.js'
import { themes } from '@/assets/themes/theme.js'
import { Banner, Toaster } from '@/models/utils/Toaster.js'
import CheckBox from '@/components/Forms/CheckBox.vue'
import Combobox from '@/components/Forms/Combobox.vue'
import { FormData } from '@/models/enums/FormData.js'
import InputText from '@/components/Forms/InputText.vue'
import { InputIcon } from '@/models/enums/InputIcon.js'
import DarkModeSwitcher from '@/components/Dashboard/Header/DarkModeSwitcher.vue'
import ListBox from '@/components/Forms/ListBox.vue'
import { ApiGatewayResponse, HttpStatusCode } from '@/api/ApiGateway.js'
import DatePicker from '@/components/Forms/DatePicker.vue'
import { DatePickerObj } from '@/models/utils/InputUtils.js'
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue'
import { Tenants } from '@/models/tenants/Tenants.js'
import MultiButtonModal from '@/components/Alerts/MultiButtonModal.vue'
import { ModalButtonData } from '@/components/Alerts/ModalButtonData.js'
import { ButtonSize, ButtonType, ButtonWidth } from '@/components/Forms/Buttons/SubmitButtonConstants.js'

const currentTheme = ref('');

//SET TRUE TO OPEN ON LOAD
const showSections = ref({ 'toasts': false, 'buttons': false, 'inputs': false, 'text': false, 'icon': false, 'surface': false, 'border': false, 'old': false, 'table': false });

//#region Radio/Modal
const plans = [ { name: 'None', type: 'none' }, { name: 'Alert', type: 'alert' }, { name: 'Info', type: 'info' } ]
const selected = ref(plans[0])
const showModal = ref(false)
//#endregion Radio/Modal

const toaster = new Toaster()
const banner = new Banner()

//#region Inputs
const input_disable = ref(false)
const input_readonly = ref(false)
const generic_switch = ref(false)
const states = FormData.STATES
const selected_state = ref('')
const selected_state2 = ref('')
const selected_state3 = ref('')
const selected_state4 = ref('')
const input_edit_modal_text1 = ref('')
const input_edit_modal_text2 = ref('')

const inputValidationError = ref(null)
const date_value = ref(new DatePickerObj('', {
	dateFormat: 'Y-m-d',
	altFormat: 'm-d-Y',
	noCalendar: false,
	enableTime: false,
	time_24hr: false,
	minuteIncrement: 1,
}))
const date_value2 = ref(new DatePickerObj('', {
	dateFormat: 'Y-m-d',
	altFormat: 'm-d-Y',
	noCalendar: false,
	enableTime: false,
	time_24hr: false,
	minuteIncrement: 1,
}))

//#region ListBoxes
const listBoxInlineValue = ref({ id: 2, text:'Item 2', disabled: false, itemIcon: false, action: '', class: '' })
const listBoxInlineData = computed(() =>
{
	return createItems(3, true);
})

const listBoxValue = ref({ id: 3, text:'Item 3', disabled: false, itemIcon: false, action: '', class: '' })
const listBoxData = computed(() =>
{
	return createItems(3, true);
})

const listBoxBlankValue = ref({ id: null, text:'', disabled: false, itemIcon: false, action: '', class: '' })
const listBoxBlankData = computed(() =>
{
	return createItems(3, true);
})

const listBoxModalValue = ref({ id: null, text:'', disabled: false, itemIcon: false, action: '', class: '' })
const listBoxModalData = computed(() =>
{
	return createItems(15, false);
})

function createItems(p_num_items, p_add_blank)
{
	let items = [];

	if (p_add_blank)
	{
		items.push({ id: 0, text:'', disabled: false, itemIcon: false, action: '', class: '' })
	}

	for (let i = 1; i <= p_num_items; i++)
	{
		items.push({ id: i, text:'Item ' + i, disabled: false, itemIcon: false, action: '', class: '' })
	}

	return items;
}
//#endregion ListBoxes

//#endregion Inputs

//#region Table
const organizationsColumns = [
	{ field: "id", title: "ID" },
	{ field: "actions", title: "Actions", sort: false },
	{ field: "organization_name", title: "Organization", width: '30%', search: true },
	{ field: "street", title: "Street", width: '30%' },
	{ field: "city", title: "City" },
	{ field: "state", title: "State" },
	{ field: "zip", title: "Zip" },
	{ field: "created_at", title: "Created", width: '20%' },
	{ field: "status", title: "Status", sort: false, width: '10%' },
]

const usersColumns = [
	{ field: "family_name", title: "Name", sort: true, width: '20%' },
	{ field: "email", title: "Email", sort: true, width: '20%' },
	{ field: "custom", title: "Permissions", sort: false },
	{ field: "deleted_at", title: "Status", sort: false, width: '1%' }
]

const userInvitesColumns = [
	{ field: "email", title: "Email", search: true, width: '15%' },
	{ field: "organization", title: "Organization" },
	{ field: "created_at", title: "Date Sent", width: '1%' },
	{ field: "status", title: "Status", width: '1%' },
	{ field: "resend", title: "Resend", sort: false, width: '1%' }
]

const advancedSearchParams = computed(() => {
	return [
		{
			"id": 'archive',
			"value": true
		}
	]
})

const endpoints = [
	new DataTableEndpointDefinition({
		endpointRoute: 'organizations/organizations',
		endpointDisplayName: 'Organizations',
		initialSortColumn: 'organization_name',
		searchPlaceholder: 'Search by organization name',
		columns: organizationsColumns,
		showCheckboxes: true,
		advancedSearchParams: advancedSearchParams
	}),
	new DataTableEndpointDefinition({
		endpointRoute: 'users/users',
		endpointDisplayName: 'Users',
		initialSortColumn: 'id',
		searchPlaceholder: 'Search by name or email',
		columns: usersColumns,
		fullTextSearch: true,
	}),
	new DataTableEndpointDefinition({
		endpointRoute: 'users/invites',
		endpointDisplayName: 'User Invites',
		enableSorting: false,
		enableSearch: false,
		initialSortColumn: 'created_at',
		searchPlaceholder: 'Search by email',
		columns: userInvitesColumns,
	})
]

const includeArchived = ref(false)
const archiveAfterDays = ref(0)

import EndpointTableListBox from '@/components/Tables/EndpointTableListBox.vue'
import { Format } from '@/models/utils/FormatUtils.js'
import EndpointTableCellMenu from '@/components/Tables/EndpointTableCellMenu.vue'
import PortalDataTable from '@/components/DataTable/PortalDataTable.vue'
import { useAuthStore } from '@/stores/authStore.js'
import ToggleSwitch from '@/components/Forms/ToggleSwitch.vue'
import { DataTableEndpointDefinition } from '@/models/datatable/DataTableEndpointDefinition.js'

const statusColumnData = computed(() =>
{
	let items = [];

	//items.push({ id: 0, text:'' })
	items.push({ id: 1, text:'Active' })
	items.push({ id: 2, text:'Disabled' })
	items.push({ id: 3, text:'Don\'t Touch Me!' })

	return items;
})

const inputEditModal1Config = computed(() => {
	return {
		title: 'Facility IDs',
		message: input_disable.value ? '' : 'Enter any number of Facility IDs.',
		text: input_edit_modal_text1.value,
		buttonSize: ButtonSize.Small,
		buttonWidth: ButtonWidth.Full,
		buttonText: input_disable.value ? 'Close' : 'Save',
		placeholder: '0123456789',
		disabled: input_disable.value,
		onButtonClicked: (text) => { debugger; input_edit_modal_text1.value = text.replaceAll('\r', ' ') },
	}
})

const inputEditModal2Config = computed(() => {
	return {
		title: 'Facility IDs',
		message: input_disable.value ? '' : 'Enter any number of Facility IDs.',
		text: input_edit_modal_text2.value,
		buttonSize: ButtonSize.Small,
		buttonWidth: ButtonWidth.Full,
		buttonText: input_disable.value ? 'Close' : 'Save',
		placeholder: '0123456789',
		disabled: input_disable.value,
		onButtonClicked: (text) => { input_edit_modal_text2.value = text },
	}
})

function onStatusItemSelected(p_item)
{
	toaster.info(p_item.text);
}

function showTextAlert(text) {
	alert(text)
}

const actionMenuItems = computed(() =>
{
	let items = [];

	items.push({ id: 1, text:'Edit' })
	items.push({ id: 2, text:'Publish' })
	items.push({ id: 3, text:'Track' })
	items.push({ id: 4, text:'Delete', hidden: true })

	return items;
})

function onMenuItemSelected(p_item)
{
	switch (p_item.text) {
		case "Edit":
			//Do edity things
			break;
	}
	alert(p_item.text + "(" + p_item.record_id + ")")
}

const table = ref(null)

function toggleArchivedContent() {
	table.value.loadData()
}
//#endregion Table

onBeforeMount(()=>{
	//Prevent a user accessing this page if it is production
	// eslint-disable-next-line no-undef
	const devEnvEh = Tenants.isDevHost();
	if (!devEnvEh) {
		router.push({ name:"dashboard"} )
	}

	currentTheme.value = themes.themeMap[window.location.hostname]
})

onMounted(() => {
	archiveAfterDays.value = Number(JSON.parse(useAuthStore().getAuth.tenantInfo().settings_json)?.data_submissions_archive_after_days?.value)

	document.getElementById('btn_' + currentTheme.value).classList.toggle('active')

	inputValidationError.value = new ApiGatewayResponse({
		'status': HttpStatusCode.ValidationError,
		'response': {
			'data': {
				'errors': [{
					'title': 'Invalid Attribute',
					'status': 422,
					'detail': `Field is required.`,
					'source': `field`
				}]
			}
		}
	}, null)
})

function changeTheme(p_theme) {

	document.getElementsByClassName('theme-switch').forEach(el => {
		el.classList.remove('active');
	});
	document.getElementById('btn_' + p_theme).classList.toggle('active')

	currentTheme.value = p_theme;

	themes.themeMap['127.0.0.1'] = p_theme
	themes.themeMap['localhost'] = p_theme
	themes.themeMap['local.aianqio.org'] = p_theme
	themes.themeMap['local.comagine.org'] = p_theme
	themes.themeMap['local.esrdnw.org'] = p_theme
	themes.themeMap['local.care.org'] = p_theme
	themes.themeMap['local.zoo.org'] = p_theme

	themes.themeMap['dev-portal.aianqio.org'] = p_theme
	themes.themeMap['dev-portal.comagine.org'] = p_theme
	themes.themeMap['dev-portal.esrdnw.org'] = p_theme
	themes.themeMap['dev-providerportal.comagine.org'] = p_theme
	themes.themeMap['dev-zoo.comagine.org'] = p_theme

	themes.themeMap['uat-portal.aianqio.org'] = p_theme
	themes.themeMap['uat-portal.comagine.org'] = p_theme
	themes.themeMap['uat-portal.esrdnw.org'] = p_theme
	themes.themeMap['uat-providerportal.comagine.org'] = p_theme
	themes.themeMap['uat-zoo.comagine.org'] = p_theme
	themes.applyTheme()
}

function getRGB(p_name)
{
	try{
		if (currentTheme.value !== '')
		{
			let rgb = themes[currentTheme.value]['--' + p_name]
			if (!rgb) rgb = themes['static']['--' + p_name]

			const discrete = rgb.split(' ');
			const hex = rgbToHex(discrete[0], discrete[1], discrete[2]).toUpperCase();

			return p_name+"\r\n (" + rgb + ")\r\n" + hex;
		}
	}
	catch(e)
	{
		console.log(p_name)
	}

	return "";
}

function rgbToHex(r, g, b)
{
	r = parseInt(r);
	g = parseInt(g);
	b = parseInt(b);
	return "#" + (1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1);
}

function showAlert()
{
	showModal.value = true;
}

function hideModal()
{
	showModal.value = false;
}
</script>

<style scoped>

.theme-switch.active{
	background-color: green;
	color: lightgray;
	font-weight: bold;
}

.form-inputs{
	@apply flex flex-row;
}

.input-group{
	@apply mr-4 mt-2 py-2 px-4 border border-neutral;
}

.style-group{
	@apply border border-black rounded-md p-4 shadow-4 mb-4;
}

.section
{
	@apply font-bold text-xl flex flex-row justify-between cursor-pointer pb-1;
}

.section-title{
	@apply text-lg
}

.applies-to
{
	@apply ml-4;
}
.example
{
	@apply ml-4 mb-4;
}

.colors{
	display:inline;
}

.text-group .colors td{
	font-weight: 800;
}

.colors td {
	font-size: 14px;
	padding: 10px 12px;
	height: 72px;
	text-align: center;
	white-space: pre;
	border: 1px solid lightgray;
}

.colors.old td {
	font-size: 16px;
	padding: 12px 14px;
	height: 40px;
	text-align: center;
}

/*
.colors tr:nth-child(n+8) td {
	color: lightgray; !* Changes the text color in rows 4, 5, 6, and so on *!
}
*/

.colors tr:first-child td {
	font-weight:bold;
	border: gray solid 1px;
}

.border-colors{
	display:inline;
}

.border-colors td {
	font-size: 14px;
	padding: 8px 10px;
	height: 72px;
	text-align: center;
	white-space: pre;
	border-width: 10px;
}

.border-colors.old td {
	font-size: 16px;
	padding: 12px 14px;
	height: 40px;
	text-align: center;
}

.border-colors tr:first-child td {
	font-weight:bold;
	border: gray solid 1px;
}

</style>